var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "menu-container", attrs: { id: _vm.id } }, [
    _c("ul", { staticClass: "esArticleMenu no-bullet" }, [
      _c(
        "li",
        {
          staticClass: "esArticleMenu__item backgroundColor-hover",
          on: { click: _vm.siteUrlEvent }
        },
        [_vm._v("リンク取得\n    ")]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "esArticleMenu__item backgroundColor-hover",
          attrs: { "data-open": "copyModal" },
          on: { click: _vm.articleCopyEvent }
        },
        [_vm._v("コピー\n    ")]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "esArticleMenu__item backgroundColor-hover",
          attrs: { "data-open": "configModal" },
          on: { click: _vm.articleConfigEvent }
        },
        [_vm._v("設定\n    ")]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "esArticleMenu__item backgroundColor-hover",
          attrs: { "data-open": "deleteModal" },
          on: { click: _vm.articleDeleteEvent }
        },
        [_vm._v("削除\n    ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }